import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/console/spaces/$joinCode/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/console/spaces/$joinCode/control",
      params: { joinCode: params.joinCode },
    });
  },
});
